import { render, staticRenderFns } from "./LoyaltyEvent.vue?vue&type=template&id=5e9af8f9"
import script from "./LoyaltyEvent.vue?vue&type=script&lang=js"
export * from "./LoyaltyEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports